<div class="cc-sidebar-container pt-1" [style.width.px]="sidebarWidth" (mouseenter)="expandSidebar()"
  (mouseleave)="collapseSidebar()">
  <nav class="nav flex-column">
    <div class="row">
      <div class="col-12">

        <div class="cc-container-btn-sidebar">
          <button type="button" class="cc-btn-sidebar" routerLink="/home" *appHasPermission="'Ver_Dashboard'"
            (click)="selectOptionSidebar('HomeProcesosSeleccion')"
            (mouseenter)="setHover('HomeProcesosSeleccion', true)"
            (mouseleave)="setHover('HomeProcesosSeleccion', false)"
            [ngClass]="{ selected: isActive('HomeProcesosSeleccion') && !sidebarComprimido }">
            <img height="40px" width="40px"
              src="/assets/img/icon-sidebar-home{{ (isActive('HomeProcesosSeleccion') || isHover('HomeProcesosSeleccion')) ? '-active' : '' }}.svg"
              [ngClass]="{ selected: isActive('HomeProcesosSeleccion') && sidebarComprimido }" />
            HOME
          </button>
        </div>


        <div class="cc-container-btn-sidebar">
          <button type="button" class="cc-btn-sidebar" routerLink="/affiliatons"
            (click)="selectOptionSidebar('PotencialesProyectos')" (mouseenter)="setHover('PotencialesProyectos', true)"
            (mouseleave)="setHover('PotencialesProyectos', false)"
            [ngClass]="{ selected: isActive('PotencialesProyectos') && !sidebarComprimido }">
            <img height="40px" width="40px"
              src="/assets/img/icon-sidebar-potenciales{{ (isActive('PotencialesProyectos') || isHover('PotencialesProyectos')) ? '-active' : '' }}.svg"
              [ngClass]="{ selected: isActive('PotencialesProyectos') && sidebarComprimido }" />
            Potenciales Proyectos
          </button>

        </div>

        <div class="cc-container-btn-sidebar" *appHasPermission="'Ver_Empresas'">
          <button type="button" class="cc-btn-sidebar" (click)="selectOptionSidebar('Empresas')"
            (mouseenter)="setHover('Empresas', true)" (mouseleave)="setHover('Empresas', false)"
            [ngClass]="{ selected: isActive('Empresas') && !sidebarComprimido }">
            <img height="40px" width="40px"
              src="/assets/img/icon-sidebar-empresas{{ (isActive('Empresas') || isHover('Empresas')) ? '-active' : '' }}.svg"
              [ngClass]="{ selected: isActive('Empresas') && sidebarComprimido }" />
            Empresas
          </button>
        </div>


        <div  class="cc-container-btn-sidebar" *appHasPermission="'Ver_Proyectos'">
          <button type="button" class="cc-btn-sidebar" (click)="selectOptionSidebar('Proyectos')"
            (mouseenter)="setHover('Proyectos', true)" (mouseleave)="setHover('Proyectos', false)"
            [ngClass]="{ selected: isActive('Proyectos') && !sidebarComprimido }">
            <img height="40px" width="40px"
              src="/assets/img/icon-sidebar-proyectos{{ (isActive('Proyectos') || isHover('Proyectos')) ? '-active' : '' }}.svg"
              [ngClass]="{ selected: isActive('Proyectos') && sidebarComprimido }" />
            Proyectos
          </button>
        </div>

        <div class="cc-container-btn-sidebar">
          <button type="button" class="cc-btn-sidebar" (click)="selectOptionSidebar('GestionFinanciera')" *appHasPermission="'Ver_grilla_Mis_Pendientes'"
            (mouseenter)="setHover('GestionFinanciera', true)" (mouseleave)="setHover('GestionFinanciera', false)"
            [ngClass]="{ selected: isActive('GestionFinanciera') && !sidebarComprimido }">
            <img height="40px" width="40px"
              src="/assets/img/icon-sidebar-gestion-financiera{{ (isActive('GestionFinanciera') || isHover('GestionFinanciera')) ? '-active' : '' }}.svg"
              [ngClass]="{ selected: isActive('GestionFinanciera') && sidebarComprimido }" />
            Gestión Financiera Proyectos
          </button>
        </div>

        <div class="cc-container-btn-sidebar">
          <button type="button" class="cc-btn-sidebar" (click)="selectOptionSidebar('Proveedores')"
            (mouseenter)="setHover('Proveedores', true)" (mouseleave)="setHover('Proveedores', false)"
            [ngClass]="{ selected: isActive('Proveedores') && !sidebarComprimido }">
            <img height="40px" width="40px"
              src="/assets/img/icon-sidebar-proveedores{{ (isActive('Proveedores') || isHover('Proveedores')) ? '-active' : '' }}.svg"
              [ngClass]="{ selected: isActive('Proveedores') && sidebarComprimido }" />
            Proveedores
          </button>
        </div>

        <div class="cc-container-btn-sidebar">
          <button type="button" class="cc-btn-sidebar" (click)="selectOptionSidebar('Usuarios')" *appHasPermission="'Ver_Usuarios'"
            (mouseenter)="setHover('Usuarios', true)" (mouseleave)="setHover('Usuarios', false)"
            [ngClass]="{ selected: isActive('Usuarios') && !sidebarComprimido }">
            <img height="40px" width="40px"
              src="/assets/img/icon-sidebar-proveedores{{ (isActive('Usuarios') || isHover('Usuarios')) ? '-active' : '' }}.svg"
              [ngClass]="{ selected: isActive('Usuarios') && sidebarComprimido }" />
            Usuarios
          </button>
        </div>


      </div>
    </div>
  </nav>
</div>